module.exports = __webpack_public_path__ + "img/Payments-action.3f8255c0.svg";